//import { CountUp } from 'countup.js';
import { checkElementInView } from '../../../js/__utils/checkElementInView';

window.addEventListener('load', () => {
	const statBlocks = document.querySelectorAll('.block-stat-simple');

	const sectionOut = () => {};

	const statObserverinView = (currentBlock, observer) => {
		if (!currentBlock || !observer) return;

		// Check if the block is already animated
		if (currentBlock.getAttribute('data-animated') === 'true') return;

		// Mark as animated
		currentBlock.setAttribute('data-animated', 'true');

		const numbers = currentBlock.querySelectorAll(
			'.wp-block-paragraph--highlight-text'
		);

		numbers.forEach((number) => {
			const text = number.innerText;
			const target = parseFloat(text);
			number.innerText = '0';

			number.parentElement.style.display = 'flex';

			const duration = 2000;
			const delay = 500;

			const startAnimation = () => {
				const startTime = performance.now();

				const updateCounter = (currentTime) => {
					const elapsed = currentTime - startTime;
					const progress = Math.min(elapsed / duration, 1);
					const currentValue = progress * target;

					number.innerText = Number.isInteger(target)
						? Math.floor(currentValue)
						: currentValue.toFixed(1);

					if (progress < 1) {
						requestAnimationFrame(updateCounter);
					} else {
						number.innerText = Number.isInteger(target)
							? target
							: target.toFixed(1);
					}
				};

				requestAnimationFrame(updateCounter);
			};

			setTimeout(startAnimation, delay);
		});

		// Properly unobserve the current block
		observer.unobserve(currentBlock);
	};

	//let statObserver;

	// Initialize observer with modified observer instance passed along
	const statObserver = checkElementInView(
		statBlocks,
		statObserverinView,
		sectionOut,
		{
			root: null,
			rootMargin: '200px',
			threshold: [0.1],
		}
	);
});
